// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"436712a7","274":"91775f5d","448":"eb214e9d","509":"4f481706","560":"d24fb872","694":"6b6edbc4","786":"d503ebf4","836":"9ea6793c"}[chunkId] + ".chunk.js";
};